'use strict';

const React = require('react');
const ReactDOM = require('react-dom');
const provideContext = require('fluxible-addons-react/provideContext');
const connectToStores = require('fluxible-addons-react/connectToStores');
const GlobalContextBaseView = require('../../global/reactHelpers/GlobalContextBaseView');

// Stores
const GalleryStore = require('../stores/GalleryStore.es');

// Actions
const galleryActions = require('../actions/galleryActions.es');
const galleryModalActions = require('../modal/galleryModalActions.es');

const { classes } = require('../helpers/GalleryConstants');

const GalleryMobileNavWrapperConnected = provideContext(
    connectToStores(require('../components/GalleryMobileNavWrapper'), [GalleryStore], context => {
        const galleryStore = context.getStore(GalleryStore);

        return {
            showSocial: galleryStore.showSocialMobile(),
            showDetails: galleryStore.showDetailsMobile(),
        };
    })
);

const GalleryMobileNavWrapper = GlobalContextBaseView.extend({
    el: `.${classes.MOBILE_NAV}`,
    initialize({ context, isModal }) {
        ReactDOM.render(
            React.createElement(GalleryMobileNavWrapperConnected, {
                context: context.getComponentContext(),
                isModal,
                actions: {
                    hideModal: payload =>
                        context.executeAction(galleryModalActions.hideModal, payload),
                    sharePhoto: payload =>
                        context.executeAction(galleryActions.sharePhoto, payload),
                    toggleSocial: payload =>
                        context.executeAction(galleryActions.toggleSocialMobile, payload),
                    toggleDetails: payload =>
                        context.executeAction(galleryActions.toggleDetailsMobile, payload),
                },
            }),
            this.el
        );
    },
});

module.exports = GalleryMobileNavWrapper;



// WEBPACK FOOTER //
// ./assets/js/gallery/views/GalleryMobileNavWrapper.es.js